module.exports = __webpack_public_path__ + "static/media/icon_del.dbad15b7.svg";